import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { get } from '../../../services/back.service';
import { FaCar, FaFileAlt, FaCalendarAlt, FaPlus, FaClock, FaArrowRight } from 'react-icons/fa';

export default function ShiftListV2() {
  const navigate = useNavigate();
  const [info, setInfo] = useState({
    pending: 0,
    hour_pending: 0,
    ready_deliver: 0,
    hour_ready_deliver: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getInfo = async () => {
      try {
        const response = await get('/dashboard/currentshift/', {});
        if (response.success && response.data) {
          setInfo(response.data);
        }
      } catch (err) {
        console.error('Error fetching dashboard shift info:', err);
      } finally {
        setLoading(false);
      }
    };
    getInfo();
  }, []);

  return (
    <div className="v2-dashboard">
      {/* Welcome Banner */}
      <div className="v2-card mb-4" style={{ background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', color: '#ffffff', border: 'none' }}>
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
          <div>
            <span className="v2-badge mb-2" style={{ background: 'rgba(226, 50, 50, 0.25)', color: '#fca5a5' }}>
              Panel Operativo v2.0
            </span>
            <h2 className="text-white mb-1" style={{ fontSize: '1.6rem' }}>Estado de Turnos e Inspecciones</h2>
            <p className="text-white-50 mb-0" style={{ fontSize: '0.9rem' }}>
              Gestión en tiempo real de peritajes y entrega de documentos en patio.
            </p>
          </div>
          <div className="d-flex flex-wrap gap-2">
            <button
              type="button"
              className="v2-btn v2-btn-primary"
              onClick={() => navigate('/createinspection/0')}
            >
              <FaPlus /> Nuevo Peritaje
            </button>
            <button
              type="button"
              className="v2-btn v2-btn-secondary"
              onClick={() => navigate('/myschedule')}
            >
              <FaCalendarAlt /> Mi Agenda
            </button>
          </div>
        </div>
      </div>

      {/* KPI Cards Grid */}
      <div className="row g-3 mb-4">
        {/* Peritajes Pendientes */}
        <div className="col-12 col-md-6">
          <div className="v2-card h-100 d-flex flex-column justify-content-between">
            <div>
              <div className="d-flex align-items-center justify-content-between mb-3">
                <span className="v2-badge v2-badge-warning">En Proceso</span>
                <div style={{ width: 40, height: 40, borderRadius: 10, background: 'rgba(226, 50, 50, 0.1)', color: '#e23232', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem' }}>
                  <FaCar />
                </div>
              </div>
              <h4 className="text-muted small text-uppercase fw-bold mb-2">Turnos En Peritaje</h4>
              <div className="d-flex align-items-baseline gap-2 mb-2">
                <span style={{ fontSize: '2.5rem', fontWeight: 800, lineHeight: 1, color: '#1e293b' }}>
                  {loading ? '...' : info.pending}
                </span>
                <span className="text-muted small">vehículos en patio</span>
              </div>
            </div>
            <div className="pt-3 border-top mt-3 d-flex align-items-center justify-content-between text-muted small flex-wrap gap-2">
              <span className="d-flex align-items-center gap-1">
                <FaClock className="text-primary-v2" /> Tiempo estimado: <strong className="text-dark ms-1">{info.hour_pending} horas</strong>
              </span>
              <button
                type="button"
                className="v2-btn v2-btn-ghost p-1 text-primary-v2"
                style={{ fontSize: '0.8rem' }}
                onClick={() => navigate('/inspectionreport')}
              >
                Ver lista <FaArrowRight size={10} className="ms-1" />
              </button>
            </div>
          </div>
        </div>

        {/* Entrega Documentos */}
        <div className="col-12 col-md-6">
          <div className="v2-card h-100 d-flex flex-column justify-content-between">
            <div>
              <div className="d-flex align-items-center justify-content-between mb-3">
                <span className="v2-badge v2-badge-success">Listos</span>
                <div style={{ width: 40, height: 40, borderRadius: 10, background: 'rgba(16, 185, 129, 0.1)', color: '#10b981', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem' }}>
                  <FaFileAlt />
                </div>
              </div>
              <h4 className="text-muted small text-uppercase fw-bold mb-2">Entrega de Documentos</h4>
              <div className="d-flex align-items-baseline gap-2 mb-2">
                <span style={{ fontSize: '2.5rem', fontWeight: 800, lineHeight: 1, color: '#1e293b' }}>
                  {loading ? '...' : info.ready_deliver}
                </span>
                <span className="text-muted small">informes listos para entrega</span>
              </div>
            </div>
            <div className="pt-3 border-top mt-3 d-flex align-items-center justify-content-between text-muted small flex-wrap gap-2">
              <span className="d-flex align-items-center gap-1">
                <FaClock className="text-success" /> Tiempo estimado: <strong className="text-dark ms-1">{info.hour_ready_deliver} horas</strong>
              </span>
              <button
                type="button"
                className="v2-btn v2-btn-ghost p-1 text-success"
                style={{ fontSize: '0.8rem' }}
                onClick={() => navigate('/inspectionreport')}
              >
                Ver lista <FaArrowRight size={10} className="ms-1" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Navigation Cards */}
      <div className="v2-card">
        <div className="v2-card-header">
          <h3>Accesos Rápidos</h3>
          <span className="text-muted small">Flujos operativos frecuentes</span>
        </div>
        <div className="row g-2">
          <div className="col-6 col-md-3">
            <button
              type="button"
              className="v2-btn v2-btn-secondary w-100 justify-content-start py-3 text-truncate"
              onClick={() => navigate('/createinspection')}
            >
              <FaCar className="text-danger flex-shrink-0" />
              <span className="text-truncate">Nuevo Peritaje</span>
            </button>
          </div>
          <div className="col-6 col-md-3">
            <button
              type="button"
              className="v2-btn v2-btn-secondary w-100 justify-content-start py-3 text-truncate"
              onClick={() => navigate('/inspectionreport')}
            >
              <FaFileAlt className="text-primary flex-shrink-0" />
              <span className="text-truncate">Reporte General</span>
            </button>
          </div>
          <div className="col-6 col-md-3">
            <button
              type="button"
              className="v2-btn v2-btn-secondary w-100 justify-content-start py-3 text-truncate"
              onClick={() => navigate('/inspectionauth')}
            >
              <FaCar className="text-warning flex-shrink-0" />
              <span className="text-truncate">Reporte Autorización</span>
            </button>
          </div>
          <div className="col-6 col-md-3">
            <button
              type="button"
              className="v2-btn v2-btn-secondary w-100 justify-content-start py-3 text-truncate"
              onClick={() => navigate('/schedules')}
            >
              <FaCalendarAlt className="text-success flex-shrink-0" />
              <span className="text-truncate">Agendamiento</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
